import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import {
    IHostLicense,
    ILicense,
} from '@models';
import { ExpiredModalComponent } from '@pages/license/modals/expired';
import { ModalService } from '@services';

@Component({
    selector: 'ui-license-status',
    templateUrl: './ui-license-status.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLicenseStatusComponent {
    @Input()
    license?: ILicense | IHostLicense;

    @Input()
    mode: 'condensed' | 'normal' = 'normal';

    constructor(private _modalService: ModalService) {}

    public openExpirationModal() {
        if (this.license && this.license.isExpired && this.license.isRegistered) {
            this._modalService.openModal(ExpiredModalComponent, this.license);
        }
    }
}
